<template>
  <v-container>
    <v-row justify="space-around">
      <v-col cols="4" md="2">
        <VitalField label="Health" vital="health" />
      </v-col>
      <v-col cols="4" md="2">
        <VitalField label="Spirit" vital="spirit" />
      </v-col>
      <v-col cols="4" md="2">
        <VitalField label="Supply" vital="supply" />
      </v-col>
    </v-row>
    <v-divider />
    <v-row>
      <v-col>
        <MomentumField />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  //import {mapState} from 'vuex';
  import VitalField from '@/components/VitalField.vue';
  import MomentumField from '@/components/MomentumField.vue';

  export default {
    name: 'Vitals',
    components: {VitalField, MomentumField},
    computed: {
      //...mapState(['characterVitals']),
    },

    methods: {},
  };
</script>
